// extracted by mini-css-extract-plugin
module.exports = {"jobs":"styles_jobs__HNnjr","jobs__filter":"styles_jobs__filter__Y3Yny","jobs__footer":"styles_jobs__footer__8ptra","jobs__link":"styles_jobs__link__yD_wX"};